var map = {
	"./ApprovedIcon.svg": 17280,
	"./BlueButton.svg": 38434,
	"./ClientBackgroundImage.svg": 34759,
	"./Ellipse.svg": 16409,
	"./FileUpload.svg": 77796,
	"./GreenButton.svg": 17358,
	"./Ok.svg": 74158,
	"./PendingIcon.svg": 32577,
	"./RejectedIcon.svg": 55629,
	"./SalesAdminBackgroundImage.svg": 10190,
	"./Sidebar-Menuphone.svg": 46490,
	"./SidebarChannelIcon.svg": 72103,
	"./SidebarTPV.svg": 1771,
	"./Sidebarmenuagent.svg": 72735,
	"./SmartDocs-Icon.svg": 58400,
	"./Totaltpvs.svg": 8403,
	"./Trashdelete.svg": 27077,
	"./Vectorupload.svg": 34785,
	"./approve.svg": 38057,
	"./arr002.svg": 29447,
	"./arr021.svg": 999,
	"./arr066.svg": 30851,
	"./arr072.svg": 29036,
	"./auditicon.svg": 4125,
	"./back_icon.svg": 97997,
	"./calendarIcon.svg": 42206,
	"./calendarIconGrey.svg": 70169,
	"./calendarWhiteIcon.svg": 57210,
	"./calendericon.svg": 92143,
	"./closeSymbol.svg": 95213,
	"./cross.svg": 18250,
	"./customerGreenIcon.svg": 68333,
	"./customersIcon.svg": 44409,
	"./danger_sign_icon.svg": 71232,
	"./defaultImage.svg": 29125,
	"./deleteButton.svg": 69737,
	"./dollarSymbol.svg": 14646,
	"./donotenroll.svg": 93062,
	"./downloadgrey.svg": 60128,
	"./drag.png": 92453,
	"./editButton.svg": 27614,
	"./electric-icon.png": 9841,
	"./error.png": 55779,
	"./export.svg": 16543,
	"./eye_show.svg": 6586,
	"./filter-fill.svg": 5469,
	"./filter.svg": 16241,
	"./filterBlueIcon.svg": 52580,
	"./filterIcon.svg": 49084,
	"./fitler-plus-blue.svg": 99570,
	"./gas-icon.png": 27371,
	"./hamburger.svg": 33337,
	"./hdSlid.svg": 82067,
	"./hd_search.svg": 23496,
	"./hd_searchsearch_blue.svg": 28321,
	"./horizon_logo.svg": 8087,
	"./logo.svg": 92609,
	"./logoicon.svg": 28649,
	"./logotpv.svg": 44824,
	"./mail.svg": 92968,
	"./notificationLogo.svg": 32542,
	"./numberOfAgents.svg": 6375,
	"./numberOfClients.svg": 90732,
	"./pause.png": 43908,
	"./pdfIcon.png": 94982,
	"./pureEnergy.png": 96707,
	"./reportIcon.svg": 9842,
	"./salesAdminBg.svg": 90353,
	"./scheduledreportsicon.svg": 13082,
	"./searchLogo.svg": 45121,
	"./sidebarClient.svg": 80050,
	"./sidebarDashboard.svg": 99807,
	"./sidebarQcUsers.svg": 96526,
	"./sidebarmenucall.png": 83703,
	"./sidebarmenuphone.png": 71122,
	"./sidebarproduct.svg": 4375,
	"./smartphone.svg": 30900,
	"./smlplus-blue.svg": 5007,
	"./smlplus.svg": 14975,
	"./successIcon.svg": 93473,
	"./swal_thinking_face.svg": 20788,
	"./tpvAdminbg.svg": 11582,
	"./tpv_logo.svg": 50717,
	"./tpvlogo.svg": 61134,
	"./upload.svg": 48583,
	"./uploadIcon.svg": 26551,
	"./uploadImageIcon.svg": 65821,
	"./userIcon.svg": 67279
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24916;